import { Component, ElementRef, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/services/auth.service';
import { LoadingService } from 'src/app/services/loading.service';
import { ReCaptchaService } from 'src/app/services/recaptcha.service';
import { passwordMatchValidator } from '../../../validators/confirm-password.validator';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
    constructor(
        private route: ActivatedRoute,
        private auth: AuthService,
        public loading: LoadingService,
        private title: Title,
        private el: ElementRef,
        private reCaptchaService: ReCaptchaService,
        private toastr: ToastrService
    ) {
        this.route.params.subscribe(e => {
            this.key = e.key;
        });
    }
    key: any;
    theForm = new FormGroup({
        password: new FormControl('', [Validators.required, Validators.minLength(6), Validators.pattern(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z0-9]).+$/)]),
        password_confirmation: new FormControl('', [Validators.required]),
    }, { validators: [passwordMatchValidator] });
    showPassword = false;
    isSuccess = false;

    async submitForm(theForm: any): Promise<void> {
        if (!theForm.valid) {
            this.el.nativeElement.querySelectorAll('[formcontrolname].ng-invalid')?.[0]?.focus();

            return;
        }

        this.loading.start();
        theForm.disable();

        try {
            const fdata = this.theForm.value;
            const token = await this.reCaptchaService.generateTokenAsync('reset_password');
            const res: any = await this.auth.resetPassword({ password: fdata.password, password_confirmation: fdata.password_confirmation, key: this.key, token });

            theForm.enable();

            if (res.success) {
                this.isSuccess = true;
                return;
            }

            if (res.response?.wrong) {
                Object.keys(res.response.wrong).forEach((key) => {
                    theForm.get(key)?.setErrors({
                        serverError: res.response.wrong[key][0]
                    });

                    this.el.nativeElement.querySelectorAll(`[formcontrolname="${key}"]`)?.[0]?.focus();
                });
            }

            const title = res.response?.message || 'Oops';
            const desc = res.response?.description || 'Error';

            this.toastr.error(desc, title);

        } catch (error) {
            theForm.enable();
            console.error(error);
            this.toastr.error('Failed to load Captcha. Please refresh the page or try again.', 'Error');

        } finally {
            this.loading.done();
        }
    }

    ngOnInit(): void {
        this.title.setTitle('Reset Password | MFGM - CMS');
    }

}
